import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result, UniversityRaw } from "../../../../interfaces";
import { Create } from "../../../universities";
import { Adapter } from "../../../../shared/adapter";
import { UniversitiesAdapter } from "../../../../adapter/universities-adapter";

export const FETCH_CREATE_UNIVERSITIES_REQUEST = 'FETCH_UNIVERSITIES_REQUEST';
export const FETCH_CREATE_UNIVERSITIES_SUCCESS = 'FETCH_UNIVERSITIES_SUCCESS';
export const FETCH_CREATE_UNIVERSITIES_FAILURE = 'FETCH_UNIVERSITIES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateUniversitiesRequest = () => {
    return {
        type: FETCH_CREATE_UNIVERSITIES_REQUEST,
    };
};

const fetchCreateUniversitiesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_UNIVERSITIES_SUCCESS,
        payload: data
    };
};

const fetchCreateUniversitiesFailure = (error: any) => {
    return {
        type: FETCH_CREATE_UNIVERSITIES_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (university:UniversityRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateUniversitiesRequest());
        try {
            const response = await Create(university);
            dispatch(fetchCreateUniversitiesSuccess(
                Adapter.from(response.data).to((value) => new UniversitiesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateUniversitiesFailure(error.message));
        }
    };
};